<script setup lang="ts">
const queryClient = useQueryClient();
await queryClient.ensureQueryData(productsQueryOptions({ slugs: ['særlig-plan'] }));
const { getBySlug } = useProducts({ slugs: ['særlig-plan'] });
const product = computed(() => getBySlug('særlig-plan'));
useSeo({ title: computed(() => product.value?.heading?.value ?? '') });

useSchemaOrg([
  defineBreadcrumb({
    itemListElement: [
      { name: 'Forside', item: '/' },
      { name: 'Kørekort', item: '/kørekort' },
      { name: computed(() => product.value?.heading?.value ?? 'Særlig plan') },
    ],
  }),
  defineCourse({
    name: computed(() => product.value?.heading?.value ?? ''),
    description: computed(() => product.value?.description?.value ? stripHtml(product.value.description.value) : ''),
    inLanguage: 'da',
    provider: { '@id': '#identity' },
  }),
]);
</script>

<template>
  <ProductContainer
    v-if="product"
    :product="product.product"
  >
    <template #illustration>
      <IconsCategorySaerligPlan />
    </template>
    <LazyVisibleContactForm
      subject="Tilmelding - Særlig plan"
      is-signup
      hydrate-on-visible
    />
  </ProductContainer>
</template>
